import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  LinearProgress,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';

import React, { memo, useRef, useState } from 'react';
import { useQuery } from 'react-query';
import { useReactToPrint } from 'react-to-print';

import useAxiosPrivate from 'hooks/useAxiosPrivate';
import ProductRow from './ProductRow';

const ViewOrder = ({ open, setOpen, itemData, setItemData, setRefetch }) => {
  const axiosPrivate = useAxiosPrivate();
  const componentRef = useRef();
  const [hasError, setHasError] = useState(false);

  const handleClose = () => {
    setOpen(false);
  };

  const { data, isLoading } = useQuery({
    queryKey: ['/admin/orders/edit', itemData?.id, open],
    queryFn: async function () {
      const response = await axiosPrivate.get(
        `/admin/orders/edit/${itemData?.id}`
      );
      return response.data.data;
    },
    enabled: !hasError && !!itemData?.id && open,
    onError: (error) => {
      setHasError(true);
      // setBlocksError(true);
    },
    retry: false,
  });

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: `Buyurtma ${data?.custom?.name} ${
      data?.custom?.phone ? ` (${data?.custom?.phone})` : ''
    }`,
    pageStyle: `
      @media print {
        @page { size: portrait; margin: 10mm;  }
      }
      body {
          -webkit-print-color-adjust: exact;
      }`,
  });

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby='alert-dialog-title'
      aria-describedby='alert-dialog-description'
      maxWidth='lg'
      PaperProps={{
        className: '!base-border !shadow-none min-w-[55vw]',
      }}
    >
      <DialogTitle
        id='alert-dialog-title'
        className='!text-center !mb-5 !bg-[#CDCDCDC7] !relative'
      >
        <span className='mr-4'>Buyurtma</span>
        <div className='absolute top-1/2 -translate-y-1/2 right-2'>
          <Button onClick={handlePrint} variant='base'>
            <i className='bi bi-printer text-lg' />
          </Button>
        </div>
      </DialogTitle>

      <DialogContent>
        <div className='component-table-wrapper' ref={componentRef}>
          <Grid
            container
            spacing={{ xs: 2, sm: 3, lg: 3 }}
            rowSpacing={1}
            columns={{ xs: 12, sm: 12, lg: 12 }}
          >
            <Grid item={true} lg={12} sm={12} xs={12}>
              <div className='rounded-md bg-gray-50 py-2 px-4'>
                Xodim: {data?.user?.name}
              </div>
            </Grid>
            <Grid item={true} lg={12} sm={12} xs={12}>
              <div className='rounded-md bg-gray-50 py-2 px-4'>
                Master: {data?.master?.name}{' '}
              </div>
            </Grid>
            <Grid item={true} lg={12} sm={12} xs={12}>
              <div className='changes-table'>
                <TableContainer className='flex-auto w-full h-full !shadow-none !base-border'>
                  <Table
                    stickyHeader
                    sx={{ width: 'inherit' }}
                    aria-labelledby='tableTitle'
                  >
                    <TableHead>
                      <TableRow>
                        <TableCell>№</TableCell>
                        <TableCell>Nomi</TableCell>
                        <TableCell>Miqdori</TableCell>
                        <TableCell>Yetkazilgan</TableCell>
                        <TableCell>Yetkazildi</TableCell>
                        <TableCell>Amallar</TableCell>
                      </TableRow>
                    </TableHead>
                    {isLoading ? (
                      <TableBody className='overflow-hidden' component='div'>
                        <TableRow component='div'>
                          <TableCell colSpan={8}>
                            <LinearProgress />
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    ) : data?.products && data?.products?.length > 0 ? (
                      <TableBody className='overflow-hidden'>
                        {data?.products.map((row, rowIndex) => (
                          <ProductRow
                            key={row?.id}
                            row={row}
                            rowIndex={rowIndex}
                          />
                        ))}
                        <TableRow
                          hover
                          tabIndex={-1}
                          key={'row-last-total-sum'}
                        >
                          <TableCell>#</TableCell>
                          <TableCell>
                            <b>Jami summa:</b>
                          </TableCell>
                          <TableCell />
                          <TableCell>
                            <b>{data?.sum?.toLocaleString()} UZS</b>
                          </TableCell>
                          <TableCell />
                          <TableCell />
                          <TableCell />
                        </TableRow>
                      </TableBody>
                    ) : (
                      <TableBody component='div'>
                        <TableRow component='div'>
                          <TableCell colSpan={8}>
                            <span className='text-gray-400 flex items-center justify-center'>
                              <i className='bi bi-exclamation-octagon text-xl leading-4 mr-1' />{' '}
                              Ma'lumot topilmadi!
                            </span>
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    )}
                  </Table>
                </TableContainer>
              </div>
            </Grid>
          </Grid>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default memo(ViewOrder);
